import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=7935007c&scoped=true&"
import script from "./LinkItem.vue?vue&type=script&lang=ts&"
export * from "./LinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./LinkItem.vue?vue&type=style&index=0&id=7935007c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935007c",
  null
  
)

export default component.exports